<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            @click="goTo()"
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >REFRESH</v-btn
        >
        <div class="d-flex ms-auto">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                  font-weight-bold
                  text-uppercase
                  btn-default btn-outline-default
                  py-2
                  px-6
                  me-2
                "
                  color="transparent"
                  small
              >
                Filter By
                <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
              </v-btn>
            </template>

            <v-list class="py-0">
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Reminders
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Newsletters
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Alerts
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-danger ls-0 font-weight-600 mb-0"
                  >
                    Remove Filter
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
              v-if="false"
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export CSV
          </v-btn>
          <v-btn
              v-if="false"
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export PDF
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl mt-3">
            <div class="px-4 pt-4">
              <h6 class="mb-1 text-typo text-h6 font-weight-bold">Articles</h6>
              <p class="text-sm text-body">Reminders and Newsletters</p>
            </div>
            <div class="px-4 py-4">
              <v-row>
                <v-col v-for="card in cards" :key="card.title" lg="3" md="6">
                  <v-card>
                    <div class="position-relative">
                      <a class="d-block shadow-xl border-radius-xl">
                        <v-img :src="card.image" class="shadow border-radius-xl">
                        </v-img>
                      </a>
                    </div>
                    <div class="px-1 pt-6">
                      <p class="text-gradient text-default mb-2 text-sm">
                        {{ card.title }}
                      </p>
                      <a href="javascript:;" class="text-decoration-none">
                        <h5 class="text-h5 font-weight-bold text-typo mb-2">
                          {{ card.style }}
                        </h5>
                      </a>
                      <p class="mb-6 text-sm text-body">
                        {{ card.description }}
                      </p>
                      <div class="d-flex align-center justify-space-between">
                        <v-btn
                            @click="goToRead(card)"
                            outlined
                            class="font-weight-bolder secondary py-4 px-5"
                            small
                        >
                          View Article
                        </v-btn>
                        <span class="avatar-group d-flex">
                        <v-tooltip
                            bottom
                            color="#212529"
                            v-for="avatar in card.avatars"
                            :key="avatar.name"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                                v-bind="attrs"
                                v-on="on"
                                size="24"
                                class="border border-white ms-n3"
                            >
                              <img :src="avatar.image" alt="Avatar" />
                            </v-avatar>
                          </template>
                          <span>{{ avatar.name }}</span>
                        </v-tooltip>
                      </span>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import TableReturns from "./Widgets/TableReturns.vue";
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Returns-List",
  components: {
    TableReturns,
  },
  data: function () {
    return {
      cards:[]
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  created () {
    this.getNews()
  },
  methods: {
    goToRead(item){
      this.$router.push({
        name: "Read",
        params: { id: item.id },
        query: { id: item.id , },
      });
    },
    async getNews() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/circular/all-circulars/' )
          .then(res => {
            if (res.status === 200) {
              this.cards = res.data
              this.cards.forEach((node) => node.image = require("@/assets/img/home-decor-1.jpg"));
              this.cards.forEach((node) => node.style = "Reminder");
              console.log(this.cards)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },

  },
};
</script>
